import * as React from "react";
import { FilterLiveSearch, useTranslate } from 'react-admin';

export default (props) => {
    const t = useTranslate();

    return (
        <FilterLiveSearch source="catalogId" label={t('components.list_filters.catalogId', { _: "Catalog ID" })} />
    )
};